import * as React from "react";

const generateSrcSet = (imageUrl, format, startingImageSize) => {
    const densities = [1, 2, 3];
    const breakpoints = [768, 1280, 1920];

    const returnedSrcSets = [];

    breakpoints.forEach(bp => {
        if (bp <= startingImageSize){
            return;
        }
        densities.forEach(dpr => {
            returnedSrcSets.push(`${imageUrl}&width=${bp}&format=${format} ${dpr}x`);
        });
    });

    return returnedSrcSets.join(', ');
};

export const Image = ({
                          imageUrl,
                          alt = "",
                          isLazy = undefined, // Keep this prop for manual override
                          classes = '',
                          style = {},
                          useSrcSet = true,
                          height = 'auto',
                          width = 'auto'
                      }) => {
    const imgRef = React.useRef(null);
    const [isAboveTheFold, setIsAboveTheFold] = React.useState(false);

    React.useEffect(() => {
        // Function to check if element is in viewport (above the fold)
        const checkIfAboveTheFold = () => {
            if (!imgRef.current) return;

            // Get viewport height (fold position)
            const viewportHeight = window.innerHeight;

            // Get element position
            const rect = imgRef.current.getBoundingClientRect();

            // Element is above the fold if it's top edge is within the viewport
            // We also consider partially visible images above the fold
            const isVisible = rect.top < viewportHeight;

            // console.log('Is above the fold:', isVisible, imageUrl);
            setIsAboveTheFold(isVisible);
        };

        // Check immediately on mount
        checkIfAboveTheFold();

        // Clean up
        return () => {
            // No cleanup needed
        };
    }, []);

    // Determine loading strategy - use manual override (isLazy) if provided, otherwise use position detection
    const loadingStrategy = isLazy === undefined ?
        (isAboveTheFold ? 'eager' : 'lazy') :
        (isLazy ? 'lazy' : 'eager');

    // console.log('Loading strategy:', isAboveTheFold,loadingStrategy, imageUrl, isLazy);
    const fetchPriority = loadingStrategy === 'eager' ? 'high' : 'auto';
    const relAttribute = loadingStrategy === 'eager' ? 'preload' : '';

    return (
        <>
            {useSrcSet && <picture>
                {/*768, 1024, 1280, 1536, 1920, 2560, 3840*/}
                <source srcSet={generateSrcSet(imageUrl, 'webp', 1920)} type="image/webp" media={`(max-width: 1920px)`}/>
                <source srcSet={generateSrcSet(imageUrl, 'webp', 1200)} type="image/webp" media={`(max-width: 1200px)`}/>
                <source srcSet={generateSrcSet(imageUrl, 'webp', 768)} type="image/webp" media={`(max-width: 768px)`}/>

                {/*<source srcSet={jpgSrcSet} type="image/jpeg" sizes={sizes}/>*/}
                <img
                    ref={imgRef}
                    src={`${imageUrl}`}
                    alt={alt}
                    loading={loadingStrategy}
                    className={classes}
                    style={style}
                    width={width}
                    height={height}
                    fetchpriority={fetchPriority}
                    rel={relAttribute}
                />
            </picture>}
            {!useSrcSet &&
                <img
                    ref={imgRef}
                    src={`${imageUrl}`} // Fallback size
                    alt={alt}
                    loading={loadingStrategy}
                    className={classes}
                    style={style}
                    width={width}
                    height={height}
                    fetchpriority={fetchPriority}
                    rel={relAttribute}
                />}
        </>
    );
};